<template>
  <div class="container mycontainer">
    <h1 class="style-h3">Contact</h1>
    <p>
      Contactez-nous si vous avez des questions ou si vous voulez rejoindre nos
      formateurs.
    </p>
    <div class="row justify-content-md-center">
      <div class="col-12 col-md-10 col-lg-8">
        <form class="form style-form" ref="anyName">
          <div class="row">
            <div class="col-8">
              <div class="row">
                <div class="col-12 col-md-12">
                  <p>
                    Par téléphone au <a href="tel:+33744529029">+33744529029</a>
                  </p>
                </div>
                <div class="col-12 col-md-12">
                  <p>
                    Par email au
                    <a href="mailto:contact@oforis.com">contact@oforis.com</a>
                  </p>
                </div>
                <div class="col-12 col-md-12">
                  <p>
                    Restons connectés, suivez nous sur Linkedin
                    <a href="https://www.linkedin.com/company/oforis/"
                      >OFORIS</a
                    >
                  </p>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="jumbotron-thumbnail">
                <img
                  src="img/QR code whatsapp_Contact page.jpeg"
                  alt=""
                  width="120px"
                  height="120px"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-12 col-md-10 col-lg-8">
        <form class="form style-form" ref="anyName" @submit.prevent="sendEmail">
          <div class="row">
            <div class="col-12 col-md-6 form-group">
              <label for="">Nom</label>
              <input
                type="text"
                id=""
                class="form-control"
                placeholder="Nom"
                name="from_name"
              />
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="">Prénom</label>
              <input
                type="text"
                id=""
                class="form-control"
                placeholder="Prénom"
                name="from_surname"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 form-group">
              <label for="">E-mail</label>
              <input
                type="text"
                id=""
                class="form-control"
                placeholder="monmail@example.com"
                name="from_email"
              />
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="">Téléphone</label>
              <input
                type="text"
                id=""
                class="form-control"
                placeholder="06..."
                name="from_telephone"
              />
            </div>
          </div>
          <div class="row">
            <div class="col form-group">
              <label for="">Sujet</label>
              <input
                type="text"
                id=""
                class="form-control"
                placeholder="Sujet"
                name="from_subject"
              />
            </div>
          </div>
          <div class="row">
            <div class="col form-group">
              <label for="">Message</label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                name="from_message"
              ></textarea>
            </div>
          </div>
          <div class="text-right">
            <button class="btn btn-primary" type="submit">Envoyer</button>
          </div>
        </form>
      </div>
    </div>
    <b-modal id="my-modal3" class="my-modal" hide-footer title="Informations">
      Votre message a bien été envoyé.
    </b-modal>
  </div>
</template>
<script>
import emailjs from "emailjs-com";
export default {
  metaInfo() {
    return {
      title: "Contactez l’équipe d’OFORIS",
      meta: [
        {
          name: "description",
          content:
            "Contactez notre équipe par mail ou par téléphone pour toute demande d’information, devis ou accompagnement personnel dans la constitution des dossiers",
        },
        {
          property: "og:title",
          content: "Contactez l’équipe d’OFORIS",
        },
        { property: "og:site_name", content: "Oforis" },
        { property: "og:type", content: "website" },
      ],
    };
  },
  methods: {
    sendEmail: function (e) {
      emailjs
        .sendForm(
          "oforis",
          "template_j0uu75f",
          e.target,
          "user_ap7EAL8OryQmv78xUxUEe"
        )
        .then(
          (result) => {
            console.log("SUCCESS!", result.status, result.text);
            this.$bvModal.show("my-modal3");
            this.$refs.anyName.reset();
          },
          (error) => {
            console.log("FAILED...", error);
          }
        );
    },
  },
};
</script>
<style scss>
body.is-home {
  background-image: None;
  background-size: 60%;
}
</style>